import styled, { css } from 'styled-components';
export const IconContainer = styled.div `
  display: flex;

  align-items: center;
  justify-content: center;

  border-radius: 100%;

  height: 18px;
  width: 18px;

  border: 2px solid var(--icon-brand);
  color: var(--icon-brand);
`;
export const Container = styled.button `
  width: 100%;
  display: flex;

  gap: var(--space-300);
  align-items: center;

  line-height: var(--font-line-height-400);
  color: var(--text-brand);
  cursor: pointer;

  &:hover {
    color: var(--text-brand-secondary);
  }

  &:hover ${IconContainer} {
    border-color: var(--icon-brand-secondary);
    color: var(--icon-brand-secondary);
  }

  ${({ disabled }) => disabled &&
    css `
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;
